export default __webpack_public_path__ + "static/media/allstar.61be30f5.mp3";